import store from "../../store/index"

// Gemeinsamer Ablauf für den persönlichen API-Key, geteilt zwischen ApiKeySettings.vue (Settings > API)
// und McpSettings.vue (Settings > MCP Server) - beide Tabs lesen/erzeugen denselben Key und sollen sich
// dabei nicht auseinander entwickeln (siehe Kommentar an personal_api_key im Store). Nimmt $http/auth der
// aufrufenden Komponente entgegen (vue-resource, Fehler als error.status/error.body), damit es ohne
// Komponente testbar bleibt.
function describeApiKeyError(error) {
    const reason = error && error.body && error.body.error
    if (error && error.status === 403) {
        if (reason === "api key access disabled for users") return "Your admin has disabled API key management for users."
        return "You are not allowed to manage an API key for this company."
    }
    return null
}

export function fetchPersonalApiKey(http, auth) {
    return http
        .post(process.env.VUE_APP_APIURL + "/user/apikey", { user_id: localStorage.id, company_id: localStorage.company_id }, { headers: { Authorization: auth } })
        .then((response) => {
            const apiKey = (response.body && response.body.api_key) || ""
            store.commit("SET_PERSONAL_API_KEY", apiKey)
            return apiKey
        })
        .catch((error) => {
            console.log(error)
            store.commit("SET_PERSONAL_API_KEY", "")
            throw { message: describeApiKeyError(error) || "Failed to load your API key." }
        })
}

export function createOrRegeneratePersonalApiKey(http, auth) {
    return http
        .post(process.env.VUE_APP_APIURL + "/user/apikey/regenerate", { user_id: localStorage.id, company_id: localStorage.company_id }, { headers: { Authorization: auth } })
        .then((response) => {
            const apiKey = (response.body && response.body.api_key) || ""
            store.commit("SET_PERSONAL_API_KEY", apiKey)
            return apiKey
        })
        .catch((error) => {
            console.log(error)
            throw { message: describeApiKeyError(error) || "Failed to generate an API key." }
        })
}
